/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RoleRead } from "../../models/role-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetRoles$Params {
  organisation_id: string;
}

export function getRoles(
  http: HttpClient,
  rootUrl: string,
  params: GetRoles$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<RoleRead>>> {
  const rb = new RequestBuilder(rootUrl, getRoles.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RoleRead>>;
    }),
  );
}

getRoles.PATH = "/surfdomeinen/organisations/{organisation_id}/auth/roles/";
